//DEVELOPMENT
//export const BASE_URL = "https://x6v45dsdj7.execute-api.us-east-1.amazonaws.com/dev/";

//PRODUCTION
export const BASE_URL = process.env.REACT_APP_BASE_URL
export const LOCATIONS_URL = 'https://nlvibl0w56.execute-api.us-east-1.amazonaws.com/prod/v1/'
